import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'
import { Cookie, Settings } from 'lucide-react'
import { useCookieConsent } from '@/contexts/CookieConsentContext'

export const CookieConsentBanner = () => {
  const { hasUserMadeChoice, acceptAll, acceptNecessary, setShowSettings } = useCookieConsent()

  if (hasUserMadeChoice) {
    return null
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4">
      <Card className="mx-auto max-w-4xl bg-background/95 backdrop-blur-sm border shadow-lg">
        <div className="p-6">
          <div className="flex items-start gap-4">
            <Cookie className="h-6 w-6 text-primary mt-1 flex-shrink-0" />
            <div className="flex-1 space-y-4">
              <div className="space-y-2">
                <h3 className="font-semibold text-lg">
                  Cookie-Einstellungen
                </h3>
                <p className="text-sm text-muted-foreground">
                  Wir verwenden Cookies, um Ihre Erfahrung zu verbessern und unsere Dienste zu optimieren. 
                  Technisch notwendige Cookies sind für die Funktionalität der Website erforderlich. 
                  Sie können Ihre Einstellungen jederzeit anpassen oder ändern.
                </p>
                <p className="text-xs text-muted-foreground">
                  Weitere Informationen finden Sie in unserer{' '}
                  <button className="underline hover:text-foreground">
                    Datenschutzerklärung
                  </button>.
                </p>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-3">
                <Button
                  onClick={acceptAll}
                  className="flex-1 sm:flex-none"
                >
                  Alle akzeptieren
                </Button>
                <Button
                  variant="outline"
                  onClick={acceptNecessary}
                  className="flex-1 sm:flex-none"
                >
                  Nur notwendige
                </Button>
                <Button
                  variant="ghost"
                  onClick={() => setShowSettings(true)}
                  className="flex-1 sm:flex-none"
                >
                  <Settings className="h-4 w-4 mr-2" />
                  Einstellungen
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  )
}